import { styled } from '@linaria/react';

import { MqTablet } from '~shared/ui/theme/media';

import { CommonInnerNav } from '../Header/styles';

export const RightContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;

	${MqTablet} {
		width: 30%;
	}
`;

export const RightContentInner = styled.nav`
	${CommonInnerNav}
	padding: 4px;
`;
